interface FilterLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export default function FilterLayout({ children, className = '' }: FilterLayoutProps) {
  return (
    <div
      className={`border-t border-[var(--anl-border)] ${className}`}
      style={{ backgroundColor: '#353a3c' }}
    >
      <div className="px-4 py-3">{children}</div>
    </div>
  );
}
